const parseToFixed = (target: number, digits?: number): number => {
  return parseFloat(target.toFixed(digits || 2));
}

export default parseToFixed;